import React, { SVGProps } from 'react'

/**
 * Feature-local "report lost or stolen" glyph for the ••• actions menu (matches
 * the design prototype). Lives here rather than in src/components/Svgs, which
 * `gen-svg-components` wipes and regenerates from src/assets/svgs — this has no
 * source asset.
 */
const SvgReportLostOrStolen = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M10 2.5l7 3.5v4c0 4-3 6.5-7 7.5-4-1-7-3.5-7-7.5V6l7-3.5Z"
      stroke={props.stroke || 'currentColor'}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default SvgReportLostOrStolen
